module.exports = "<div class=\"modal-header\">\n  <button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"cancel()\">&times;</button>\n  <h2 class=\"modal-title\">Complete Your Profile</h2>\n</div>\n\n<div class=\"modal-body\">\n  <complete-profile callback=\"done\" config=\"config\"></complete-profile>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/services/modal/completeProfile/completeProfile.html
// module id = 871
// module chunks = 1